export const csrfToken = () => {
    const tags = document.getElementsByName('csrf-token');

    return tags.length ? tags[0].getAttribute('content') : '';
};



// WEBPACK FOOTER //
// ./scripts/utils.js